import { useReverseENSLookUp } from '../../utils/ensLookup';
import { resolveNounContractAddress } from '../../utils/resolveNounsContractAddress';
import { useEthers } from '@usedapp/core';
import classes from './ShortAddress.module.css';
import { containsBlockedText } from '../../utils/moderation/containsBlockedText';
import { useShortAddress } from '../../utils/addressAndENSDisplayUtils';
import React from 'react';
import Identicon from '../Identicon';
import { useIsNetworkEnsSupported } from '../../hooks/useIsNetworkEnsSupported';

const ShortAddress: React.FC<{ address: string; avatar?: boolean; size?: number; largeText?: boolean }> = props => {
  const { address, avatar, size = 24, largeText = false } = props;
  const { library: provider } = useEthers();
  const hasENS = useIsNetworkEnsSupported();
  const ens = useReverseENSLookUp(address) || resolveNounContractAddress(address);
  const ensMatchesBlocklistRegex = containsBlockedText(ens || '', 'en');
  const shortAddress = useShortAddress(address);

  if (avatar) {
    return (
      <div className={largeText ? classes.shortAddressLargeText: classes.shortAddress}>
        {hasENS && avatar && (
          <div key={address}>
            <Identicon size={size} address={address} provider={provider} />
          </div>
        )}
        <span>{ens && !ensMatchesBlocklistRegex ? ens : shortAddress}</span>
      </div>
    );
  }

  return <>{ens && !ensMatchesBlocklistRegex ? ens : shortAddress}</>;
};

export default ShortAddress;
